export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  image: string;
  author: string;
  date: string;
  readTime: string;
  tags: string[];
  featured: boolean;
}

export const articles: Article[] = [
  {
    slug: 'paris-fashion-week-2026-trends',
    title: '2026巴黎时装周：五大趋势重新定义欧美时尚版图',
    excerpt: '本季巴黎时装周呈现出令人耳目一新的设计语言，从可持续面料到数字化秀场，欧美时尚正在经历一场深刻的变革。',
    content: `<p>2026年的巴黎时装周刚刚落下帷幕，本季秀场呈现出的创新与突破令人印象深刻。从Chanel到Louis Vuitton，各大品牌纷纷展示了对未来时尚的独特理解。</p>
<h2>可持续时尚成为主流</h2>
<p>本季最显著的趋势是可持续时尚从概念走向实践。Stella McCartney展示了完全采用生物降解材料制成的系列，而Gucci则推出了使用再生面料的胶囊系列。欧美时尚产业正在以实际行动回应环保呼声。</p>
<h2>数字化与现实的融合</h2>
<p>Balenciaga的秀场融合了AR技术，观众可以通过手机App看到虚拟模特与真实模特的互动走秀。这一创新标志着欧美时尚进入虚实融合的新纪元。</p>
<h2>中性化设计崛起</h2>
<p>性别流动的设计理念在本季达到高潮。多个品牌推出了不分性别的服装系列，打破了传统欧美时尚中男女装的严格界限。</p>
<h2>复古回潮：90年代极简主义</h2>
<p>受90年代欧美时尚影响，极简剪裁和中性色调强势回归。Prada和Jil Sander成为这一趋势的领军者。</p>
<h2>艺术联名成为标配</h2>
<p>从Louis Vuitton与Jeff Koons的合作到Dior与当代艺术家的联名，艺术与欧美时尚的跨界合作比以往任何时候都更加紧密。</p>`,
    category: 'fashion',
    categoryName: '欧美时尚',
    image: 'https://readdy.ai/api/search-image?query=Paris%20Fashion%20Week%20runway%20show%20with%20elegant%20models%20in%20contemporary%20designer%20outfits%2C%20dramatic%20lighting%2C%20minimalist%20white%20stage%2C%20editorial%20fashion%20photography%2C%20clean%20sophisticated%20aesthetic%20with%20warm%20neutral%20background&width=1200&height=800&seq=article-fashion-01&orientation=landscape',
    author: '陈思涵',
    date: '2026-08-08',
    readTime: '8分钟',
    tags: ['巴黎时装周', '欧美时尚', '流行趋势', '可持续时尚'],
    featured: true,
  },
  {
    slug: 'taylor-swift-eras-tour-record',
    title: 'Taylor Swift「时代巡演」破纪录：欧美音乐史上最伟大的巡演',
    excerpt: 'Taylor Swift的Eras Tour继续刷新全球巡演票房纪录，成为欧美音乐史上商业最成功的巡演，同时重新定义了演唱会体验。',
    content: `<p>Taylor Swift的「时代巡演」（The Eras Tour）自开演以来，持续打破各项纪录。截至2026年夏季，该巡演已成为欧美音乐史上票房最高的巡演。</p>
<h2>数据背后的震撼</h2>
<p>据Billboard统计，Eras Tour已累计售出超过1000万张门票，总票房突破20亿美元，远超此前的纪录保持者。每一站演出都引发了当地的欧美音乐热潮。</p>
<h2>文化现象级影响力</h2>
<p>Eras Tour的影响力远超音乐本身。从城市经济提振到社交媒体话题，这场巡演已成为2020年代最具标志性的欧美音乐文化事件。</p>
<h2>音乐叙事的革新</h2>
<p>在欧美音乐的演唱会领域，Eras Tour以其独特的「时代」叙事结构——横跨Taylor全部专辑时代——开创了全新的演唱会策划模式。</p>`,
    category: 'music',
    categoryName: '欧美音乐',
    image: 'https://readdy.ai/api/search-image?query=Massive%20stadium%20concert%20with%20colorful%20stage%20lights%20and%20huge%20crowd%2C%20epic%20music%20performance%20atmosphere%2C%20dramatic%20evening%20sky%2C%20warm%20golden%20and%20pink%20stage%20lighting%2C%20grand%20scale%20live%20music%20photography&width=1200&height=800&seq=article-music-01&orientation=landscape',
    author: '林小雨',
    date: '2026-08-06',
    readTime: '6分钟',
    tags: ['Taylor Swift', '欧美音乐', 'Eras Tour', '演唱会'],
    featured: true,
  },
  {
    slug: 'oppenheimer-nolan-cinema-legacy',
    title: '诺兰的《奥本海默》之后：欧美影视的历史叙事新高度',
    excerpt: '克里斯托弗·诺兰以《奥本海默》重新定义了欧美影视中的历史传记类型，其对科学与道德的探讨引发了全球范围内的深度讨论。',
    content: `<p>《奥本海默》不仅是一部关于原子弹之父的传记电影，更是欧美影视在历史叙事维度上的一次重大突破。</p>
<h2>非线性叙事的极致运用</h2>
<p>诺兰标志性的非线性叙事在《奥本海默》中达到了新的艺术高度。黑白与彩色画面的交替使用，不仅区分了主观与客观视角，更在欧美影视中开创了全新的叙事语法。</p>
<h2>科学与道德的永恒命题</h2>
<p>影片探讨的核心——科学家在面对毁灭性武器时的道德困境——在当下具有前所未有的现实意义。这也是欧美影视能够引发全球共鸣的原因所在。</p>`,
    category: 'film',
    categoryName: '欧美影视',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20scene%20with%20dramatic%20lighting%20and%20deep%20shadows%2C%20vintage%20scientific%20laboratory%20aesthetic%2C%20intense%20atmosphere%2C%20black%20and%20white%20photography%20style%20with%20warm%20sepia%20tones%2C%20classic%20Hollywood%20cinematography&width=1200&height=800&seq=article-film-01&orientation=landscape',
    author: '王浩然',
    date: '2026-08-04',
    readTime: '7分钟',
    tags: ['奥本海默', '诺兰', '欧美影视', '电影评论'],
    featured: true,
  },
  {
    slug: 'chanel-creative-direction-future',
    title: 'Chanel创意总监更迭：百年品牌的传承与革新之路',
    excerpt: 'Chanel新任创意总监的上任标志着这个百年欧美奢侈品牌进入全新篇章，如何在传统与创新之间找到平衡成为最大看点。',
    content: `<p>Chanel作为欧美品牌中最具标志性的奢侈品牌之一，其创意总监的更迭总是引发全行业关注。</p>
<h2>百年传承的底蕴</h2>
<p>自Gabrielle Chanel创立品牌以来，Chanel始终代表着欧美品牌中最高级别的工艺水准与设计美学。从经典的小黑裙到标志性的斜纹软呢外套，每一件作品都承载着深厚的历史底蕴。</p>
<h2>创新与突破的挑战</h2>
<p>在保持品牌DNA的同时，新创意总监面临着将Chanel带入数字化时代的挑战。欧美品牌的未来，需要在虚拟世界与现实世界之间架起桥梁。</p>`,
    category: 'brand',
    categoryName: '欧美品牌',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20fashion%20boutique%20interior%20with%20elegant%20Chanel%20style%20display%2C%20golden%20accents%20and%20cream%20marble%2C%20sophisticated%20retail%20atmosphere%2C%20soft%20warm%20lighting%2C%20timeless%20European%20luxury%20aesthetic&width=1200&height=800&seq=article-brand-01&orientation=landscape',
    author: '陈思涵',
    date: '2026-08-02',
    readTime: '5分钟',
    tags: ['Chanel', '欧美品牌', '奢侈品牌', '时尚'],
    featured: false,
  },
  {
    slug: 'italian-renaissance-modern-influence',
    title: '意大利文艺复兴如何塑造了今日的欧美文化审美',
    excerpt: '从达芬奇到米开朗基罗，意大利文艺复兴的人文主义精神至今仍深刻影响着欧美文化的方方面面。',
    content: `<p>文艺复兴不仅仅是艺术史上的一个时期，它是整个欧美文化的精神源头。从14世纪的意大利开始，这场伟大的文化运动彻底改变了西方世界的思想面貌。</p>
<h2>人文主义的诞生</h2>
<p>文艺复兴的核心——人文主义——将人的价值置于中心地位。这一思想成为欧美文化最根本的精神内核，影响了之后数百年的哲学、文学和艺术发展。</p>
<h2>影响延续至今</h2>
<p>今天，当我们谈论欧美文化中的个人主义、创新精神和审美追求时，都能追溯到文艺复兴时期的源头。从硅谷的创新文化到当代艺术的多元表达，文艺复兴的精神仍在延续。</p>`,
    category: 'culture',
    categoryName: '欧美文化',
    image: 'https://readdy.ai/api/search-image?query=Italian%20Renaissance%20art%20gallery%20with%20classical%20paintings%20and%20frescoes%2C%20warm%20golden%20light%2C%20ornate%20architecture%2C%20marble%20sculptures%2C%20elegant%20cultural%20heritage%20atmosphere%2C%20timeless%20European%20art%20museum&width=1200&height=800&seq=article-culture-01&orientation=landscape',
    author: '张明远',
    date: '2026-07-30',
    readTime: '10分钟',
    tags: ['文艺复兴', '欧美文化', '艺术史', '意大利'],
    featured: false,
  },
  {
    slug: 'scandinavian-hygge-lifestyle-guide',
    title: '北欧Hygge生活哲学：欧美生活方式中的温暖美学',
    excerpt: 'Hygge——这个源自丹麦的生活理念，已经成为全球欧美生活方式爱好者追求的理想状态。让我们深入解读Hygge的核心。',
    content: `<p>在快节奏的现代生活中，源自北欧的Hygge理念为欧美生活方式注入了温暖与宁静。这个无法用单一词汇翻译的丹麦语概念，代表了一种舒适、满足的生活状态。</p>
<h2>Hygge的核心要素</h2>
<p>烛光、温暖的毛毯、一杯热饮、与挚友的温馨时光——这些看似简单的元素构成了Hygge的精髓。在欧美生活方式中，Hygge代表了对生活品质的追求。</p>
<h2>从北欧到世界的传播</h2>
<p>近年来，Hygge已经从北欧走向全球，成为欧美生活方式中最受推崇的理念之一。从家居设计到日常习惯，越来越多的人开始实践这种温暖的生活美学。</p>`,
    category: 'lifestyle',
    categoryName: '欧美生活',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20Scandinavian%20living%20room%20with%20candles%20and%20warm%20textiles%2C%20soft%20natural%20light%20through%20large%20windows%2C%20minimalist%20Nordic%20interior%20design%2C%20comfortable%20hygge%20atmosphere%2C%20cream%20and%20beige%20tones&width=1200&height=800&seq=article-lifestyle-01&orientation=landscape',
    author: '林小雨',
    date: '2026-07-28',
    readTime: '6分钟',
    tags: ['Hygge', '欧美生活', '北欧', '生活方式'],
    featured: true,
  },
  {
    slug: 'milan-fashion-week-street-style',
    title: '米兰时装周街拍精选：欧美时尚达人的穿搭哲学',
    excerpt: '米兰时装周不仅是T台的盛宴，街头的欧美时尚达人们同样用穿搭诠释着当季最前沿的流行密码。',
    content: `<p>米兰时装周的街头，从来不缺少令人惊艳的欧美时尚穿搭。2026秋冬米兰时装周期间，来自全球的时尚达人齐聚这座意大利时尚之都。</p>
<h2>色彩趋势：温暖大地色系</h2>
<p>本季街头欧美时尚的主色调回归温暖的大地色系——焦糖棕、橄榄绿、奶油白成为最受追捧的颜色，营造出高级且低调的视觉感受。</p>
<h2>层次感叠穿</h2>
<p>意大利人最擅长的层次感叠穿在本次时装周街头得到了淋漓尽致的展现。不同材质、不同长度的单品巧妙组合，展现出欧美时尚中独有的effortless chic。</p>`,
    category: 'fashion',
    categoryName: '欧美时尚',
    image: 'https://readdy.ai/api/search-image?query=Milan%20fashion%20week%20street%20style%20photography%2C%20elegantly%20dressed%20people%20on%20historic%20Italian%20streets%2C%20warm%20autumn%20sunlight%2C%20sophisticated%20European%20fashion%20atmosphere%2C%20candid%20editorial%20style&width=1200&height=800&seq=article-fashion-02&orientation=landscape',
    author: '陈思涵',
    date: '2026-07-25',
    readTime: '5分钟',
    tags: ['米兰时装周', '欧美时尚', '街拍', '穿搭'],
    featured: false,
  },
  {
    slug: 'beatles-musical-revolution-legacy',
    title: '披头士乐队：欧美音乐史上无法超越的传奇',
    excerpt: '六十多年过去了，披头士乐队在欧美音乐史上的地位依然无可撼动。他们的音乐创新精神至今影响着全球音乐人。',
    content: `<p>回顾欧美音乐的发展历程，Beatles无疑是最耀眼的名字。这支来自利物浦的四人乐队，从根本上改变了流行音乐的面貌。</p>
<h2>音乐创新的先驱</h2>
<p>从早期的摇滚到后期的实验性作品，Beatles在短短十年间完成了欧美音乐史上最令人惊叹的进化。录音室技术的革新、音乐风格的融合、歌词深度的提升——Beatles在每一个维度上都推动了欧美音乐向前迈进。</p>
<h2>文化符号的意义</h2>
<p>Beatles不仅是音乐现象，更是整个1960年代欧美文化变革的缩影。他们的影响力远超音乐本身，深入到了社会思潮和生活方式之中。</p>`,
    category: 'music',
    categoryName: '欧美音乐',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20recording%20studio%20with%20classic%20microphones%20and%20instruments%2C%20warm%20analog%20equipment%2C%20nostalgic%201960s%20atmosphere%2C%20soft%20golden%20lighting%2C%20classic%20rock%20music%20heritage%20aesthetic&width=1200&height=800&seq=article-music-02&orientation=landscape',
    author: '林小雨',
    date: '2026-07-22',
    readTime: '9分钟',
    tags: ['Beatles', '欧美音乐', '摇滚', '经典'],
    featured: false,
  },
  {
    slug: 'apple-brand-strategy-analysis',
    title: 'Apple品牌策略深度解析：欧美科技品牌的成功密码',
    excerpt: 'Apple作为全球最具价值的欧美品牌之一，其品牌策略值得深入研究。从产品设计到营销叙事，Apple定义了现代科技品牌的标准。',
    content: `<p>在欧美品牌中，Apple无疑是最具影响力的科技品牌。从Mac到iPhone再到Vision Pro，Apple持续引领着消费电子产业的方向。</p>
<h2>极简主义的设计哲学</h2>
<p>Apple的设计理念——极简、直观、人性化——已经成为整个科技行业的标准。这种设计哲学深深植根于欧美品牌所崇尚的包豪斯传统。</p>
<h2>生态系统的力量</h2>
<p>Apple最令人称道的品牌策略之一是其无缝的生态系统。从硬件到软件到服务，每一个环节都经过精心设计，这也是欧美品牌中少有的全链路掌控能力。</p>`,
    category: 'brand',
    categoryName: '欧美品牌',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20tech%20showroom%20with%20clean%20wooden%20tables%20and%20sleek%20devices%2C%20warm%20natural%20lighting%2C%20Apple%20store%20aesthetic%2C%20sophisticated%20retail%20design%2C%20cream%20and%20wood%20tones&width=1200&height=800&seq=article-brand-02&orientation=landscape',
    author: '王浩然',
    date: '2026-07-20',
    readTime: '7分钟',
    tags: ['Apple', '欧美品牌', '科技', '品牌策略'],
    featured: false,
  },
  {
    slug: 'dune-part-two-visual-masterpiece',
    title: '《沙丘2》：欧美影视科幻美学的巅峰之作',
    excerpt: '丹尼斯·维伦纽瓦的《沙丘2》将欧美影视的科幻美学推向了新的高度，宏大的史诗叙事与精妙的视觉语言完美融合。',
    content: `<p>《沙丘2》的上映，无疑是2026年欧美影视界最受瞩目的事件之一。维伦纽瓦延续了第一部的史诗气质，并在视觉呈现上达到了前所未有的高度。</p>
<h2>视觉语言的突破</h2>
<p>从阿拉基斯沙漠的壮丽景观到哈克南星球的诡异美学，《沙丘2》在欧美影视的视觉呈现上树立了新的标准。每一帧画面都堪称艺术品。</p>
<h2>叙事深度的提升</h2>
<p>相比第一部，《沙丘2》在人物塑造和主题探讨上更加深入。对权力、信仰和生态的思考，使这部欧美影视作品超越了一般的科幻片范畴。</p>`,
    category: 'film',
    categoryName: '欧美影视',
    image: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20desert%20landscape%20with%20dramatic%20golden%20sunset%20lighting%2C%20vast%20sand%20dunes%2C%20grand%20scale%20sci-fi%20atmosphere%2C%20warm%20earth%20tones%2C%20Hollywood%20blockbuster%20cinematography%20aesthetic&width=1200&height=800&seq=article-film-02&orientation=landscape',
    author: '王浩然',
    date: '2026-07-18',
    readTime: '8分钟',
    tags: ['沙丘', '欧美影视', '科幻', '维伦纽瓦'],
    featured: false,
  },
  {
    slug: 'french-cafe-culture-philosophy',
    title: '法式咖啡馆文化：欧美生活方式中的慢生活哲学',
    excerpt: '法国咖啡馆不仅仅是喝咖啡的地方，它是欧美生活方式中社交、思考与创作的灵魂空间。',
    content: `<p>在欧美生活方式中，法国咖啡馆文化占据着无可替代的位置。从巴黎左岸的花神咖啡馆到普罗旺斯小镇的路边咖啡馆，这些空间承载着法式生活的精髓。</p>
<h2>咖啡馆作为第三空间</h2>
<p>在欧美生活的语境中，咖啡馆是介于家庭和工作场所之间的「第三空间」。这里是思想碰撞、艺术创作和社交互动的温床。</p>
<h2>慢生活的艺术</h2>
<p>法式咖啡馆文化的核心是「慢」——慢慢品尝一杯浓缩咖啡，慢慢阅读一本书，慢慢与朋友交谈。这种慢生活哲学在快节奏的当代社会中显得尤为珍贵。</p>`,
    category: 'lifestyle',
    categoryName: '欧美生活',
    image: 'https://readdy.ai/api/search-image?query=Classic%20Parisian%20sidewalk%20cafe%20with%20wooden%20chairs%20and%20marble%20tables%2C%20warm%20afternoon%20sunlight%2C%20charming%20European%20street%20scene%2C%20relaxed%20atmosphere%2C%20cream%20and%20terracotta%20tones&width=1200&height=800&seq=article-lifestyle-02&orientation=landscape',
    author: '张明远',
    date: '2026-07-15',
    readTime: '6分钟',
    tags: ['法国', '咖啡馆', '欧美生活', '慢生活'],
    featured: false,
  },
  {
    slug: 'greek-mythology-modern-culture',
    title: '古希腊神话：欧美文化永不枯竭的灵感源泉',
    excerpt: '从文学到影视，从品牌命名到建筑设计，古希腊神话在欧美文化中的影响力无处不在且历久弥新。',
    content: `<p>古希腊神话是欧美文化最重要的基石之一。三千年来，这些动人的故事持续滋养着西方的文学、艺术和思想。</p>
<h2>神话原型的现代演绎</h2>
<p>从好莱坞电影到畅销小说，古希腊神话中的原型角色不断被重新诠释。宙斯、赫拉、阿波罗这些名字不仅仅是神话人物，更是欧美文化中根深蒂固的文化符号。</p>
<h2>哲学思想的源头</h2>
<p>古希腊哲学——从苏格拉底到亚里士多德——奠定了欧美文化的思维方式。理性思辨、民主理念、美学追求，这些西方核心价值观都可以追溯到古希腊。</p>`,
    category: 'culture',
    categoryName: '欧美文化',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Greek%20temple%20ruins%20with%20warm%20golden%20sunset%20light%2C%20Corinthian%20columns%2C%20marble%20architecture%2C%20Mediterranean%20landscape%2C%20timeless%20classical%20heritage%20atmosphere&width=1200&height=800&seq=article-culture-02&orientation=landscape',
    author: '张明远',
    date: '2026-07-12',
    readTime: '8分钟',
    tags: ['古希腊', '欧美文化', '神话', '哲学'],
    featured: false,
  },
];

export const getArticleBySlug = (slug: string) => {
  return articles.find((a) => a.slug === slug);
};

export const getArticlesByCategory = (categorySlug: string) => {
  return articles.filter((a) => a.category === categorySlug);
};

export const getFeaturedArticles = () => {
  return articles.filter((a) => a.featured);
};

export const getRelatedArticles = (article: Article, limit = 4) => {
  return articles
    .filter((a) => a.slug !== article.slug && a.category === article.category)
    .slice(0, limit);
};